import { Fetcher } from '@this/src/util';
import type { ShareholderTicketFeeOrganizationOption } from './shareholder_ticket_fees_organization_select';

interface Response {
  organizations: ShareholderTicketFeeOrganizationOption[];
}

export const fetchShareholderTicketFeeOrganizations = async (): Promise<
  ShareholderTicketFeeOrganizationOption[]
> => {
  const result = await Fetcher.get<Response>('/arrangement/organizations/autocomplete.json', { q: '' });

  return result.organizations;
};
